const syncWishlistButton = wishlist => {
  const button = wishlist.shadowRoot?.querySelector('button')
  if (!button) return
  button.setAttribute('aria-pressed', String(wishlist.hasAttribute('saved')))
}

const syncWishlistButtons = root => {
  if (root.matches?.('gw-wishlist-button')) syncWishlistButton(root)
  root.querySelectorAll?.('gw-wishlist-button').forEach(syncWishlistButton)
}

customElements.whenDefined('gw-wishlist-button').then(() => {
  syncWishlistButtons(document)

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes') {
        syncWishlistButton(mutation.target)
        return
      }
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) syncWishlistButtons(node)
      })
    })
  })

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['saved'],
    childList: true,
    subtree: true,
  })
})
